export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9863.4eb8510a.jpg";